<div class="lookup-page">
  <section class="lookup-card">
    <span class="lookup-title">License Lookup</span>
    <p class="lookup-hint">
      Check any domain's Chargify license state — including prospects that
      aren't set up in SPOG yet. "Refresh from Chargify" bypasses the 24-hour
      cache (use after a renewal or new trial).
    </p>
    <input
      class="lookup-input"
      type="text"
      name="domain"
      placeholder="school.edu"
      autocomplete="off"
      spellcheck="false"
      [(ngModel)]="domain"
      (keyup.enter)="onEnter()"
    />
    <cdw-license-check-panel [domain]="domain"></cdw-license-check-panel>
  </section>
</div>
